/*
 * «GitLab платформы»: адрес, редакция и версия, KAS (адрес для GitLab Agent кластеров), где работает,
 * какие кластеры собирают метрики. Версия и KAS — из сводки viva-gitlab, остальное — из сущности.
 */
import { Grid } from '@material-ui/core';
import { InfoCard, Link, Progress } from '@backstage/core-components';
import { EntityRefLink, useEntity } from '@backstage/plugin-catalog-react';
import { annotation, entityClusters, GITLAB_URL_ANNOTATION } from '../../../lib/viva';
import { Field, useFieldStyles } from './Field';
import { useGitlabSummary } from './useGitlabSummary';

export const GitlabInstanceCard = () => {
  const classes = useFieldStyles();
  const { entity } = useEntity();
  const { value, loading, error } = useGitlabSummary();
  const dash = <span className={classes.muted}>—</span>;
  const url = annotation(entity, GITLAB_URL_ANNOTATION) ?? value?.url;
  const clusters = entityClusters(entity).map(c => c.cluster);
  const problem = error?.message ?? value?.error;

  return (
    <InfoCard title="GitLab платформы">
      {loading && <Progress />}
      <Grid container spacing={2}>
        <Field label="Адрес" full>
          {url ? <Link to={url}>{url}</Link> : dash}
        </Field>
        <Field label="Версия">
          {value?.version ? (
            <span className={classes.mono}>
              {value.edition ?? 'CE'} {value.version}
            </span>
          ) : (
            dash
          )}
        </Field>
        <Field label="Ревизия">
          {value?.revision ? <span className={classes.mono}>{value.revision}</span> : dash}
        </Field>
        <Field label="KAS (агенты кластеров)" full>
          {value?.kas ? (
            <>
              {value.kas.enabled ? 'включён' : 'выключен'}
              {value.kas.version ? `, ${value.kas.version}` : ''}
              {value.kas.externalUrl && (
                <div className={classes.mono}>{value.kas.externalUrl}</div>
              )}
            </>
          ) : (
            dash
          )}
        </Field>
        <Field label="Где работает">бутстрап-нода платформы (контейнер infra-gitlab)</Field>
        <Field label="Метрики собирает">
          {clusters.length > 0 ? (
            <div className={classes.chips}>
              {clusters.map(c => (
                <EntityRefLink key={c} entityRef={`resource:default/${c}`} />
              ))}
            </div>
          ) : (
            <span className={classes.muted}>
              ни один кластер — включите «Метрики GitLab платформы» при создании кластера
            </span>
          )}
        </Field>
        {problem && (
          <Field label="Ошибка" full>
            <span className={classes.muted}>{problem}</span>
          </Field>
        )}
      </Grid>
    </InfoCard>
  );
};
